module.exports = __webpack_public_path__ + "img/744.a90ebf3b.jpg";